import { environment as encrytedEnvironment } from './environment';
import { AES, enc } from 'crypto-js';

const decodeString = (str: string): string => {
  let decodeBytes = AES.decrypt(
    str,
    decodeBase64(encrytedEnvironment.secretKey)
  );
  if (decodeBytes.toString()) return decodeBytes.toString(enc.Utf8);

  throw new Error('no posible decrypt env variable');
};

const decodeBase64 = (str: string): string => {
  return enc.Utf8.stringify(enc.Base64.parse(str));
};

const NO_ENCRYPTED_VARIABLES = [
  'production',
  'shoppingcart',
  'excludedProductsList',
];
const SECRET_KEY_NAME = 'secretKey';

// use to know if var has been already decrypted
const decodeCache = new Map<string, any>();

const handler = {
  get: (target: any, prop: any) => {
    try {
      if (decodeCache.has(prop)) return decodeCache.get(prop);
      let decode = '';
      if (prop === SECRET_KEY_NAME) {
        decode = decodeBase64(target[prop]);
      } else {
        decode = NO_ENCRYPTED_VARIABLES.includes(prop)
          ? Reflect.get(target, prop)
          : decodeString(target[prop]);
      }
      return decodeCache.set(prop, decode).get(prop);
    } catch (e) {
      return Reflect.get(target, prop);
    }
  },
};

const environment = new Proxy<typeof encrytedEnvironment>(encrytedEnvironment, handler);

export { environment };